import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import NoItemResult from '../../../components/results/NoItemResult';
import hasPermissions from '../../../utilities/hasPermissions';
import { useAddDealerDrawer } from './UserGroupAddDealerDrawer';

export type UserGroupDealerEmptyListProps = { userGroup: UserGroupSpecsFragment };

const UserGroupDealerEmptyList = ({ userGroup }: UserGroupDealerEmptyListProps) => {
    const { t } = useTranslation(['userGroupDetails']);
    const addDealerDrawer = useAddDealerDrawer(userGroup);
    const { permissions: accountPermissions } = useAccount();
    const company = useCompany(true);
    const hasPermission = company
        ? hasPermissions(company.permissions, [permissionKind.createUserGroup]) &&
          hasPermissions(accountPermissions, [permissionKind.createUserGroup])
        : hasPermissions(accountPermissions, [permissionKind.createUserGroup]);

    return (
        <NoItemResult
            extra={
                <>
                    {hasPermission && (
                        <Button onClick={addDealerDrawer.open} type="primary">
                            {t('userGroupDetails:tabs.dealers.noData.action')}
                        </Button>
                    )}
                    {addDealerDrawer.render()}
                </>
            }
            subTitle={t('userGroupDetails:tabs.dealers.noData.message')}
        />
    );
};

export default UserGroupDealerEmptyList;
